// src/components/TestimonialForm.js
import { useState } from 'react';
import { FiStar } from 'react-icons/fi';

function TestimonialForm({ onSubmit }) {
  const [open, setOpen]     = useState(false);
  const [rating, setRating] = useState(0);
  const [hover, setHover]   = useState(0);
  const [name, setName]     = useState('');
  const [role, setRole]     = useState('');
  const [body, setBody]     = useState('');
  const [submitted, setSubmitted] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    if (!rating || !name.trim() || !body.trim()) return;
    onSubmit({ name: name.trim(), role: role.trim(), body: body.trim(), rating });
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setOpen(false);
      setRating(0);
      setName('');
      setRole('');
      setBody('');
    }, 2000);
  }

  return (
    <div className="testimonial-form-wrapper">
      {!open && (
        <button className="btn-cta" onClick={() => setOpen(true)}>
          Leave a Review
        </button>
      )}

      {open && (
        <form className="testimonial-form" onSubmit={handleSubmit}>
          <h3 className="testimonial-form-title">Share Your Experience</h3>

          {/* Star Rating */}
          <div className="form-field">
            <label className="form-label">Your Rating</label>
            <div className="star-input">
              {[1, 2, 3, 4, 5].map(star => (
                <button
                  key={star}
                  type="button"
                  className={`star-btn ${star <= (hover || rating) ? 'active' : ''}`}
                  onClick={() => setRating(star)}
                  onMouseEnter={() => setHover(star)}
                  onMouseLeave={() => setHover(0)}
                  aria-label={`${star} star${star > 1 ? 's' : ''}`}
                >
                  <FiStar size={24} />
                </button>
              ))}
            </div>
          </div>

          <div className="form-field">
            <label className="form-label">Your Name *</label>
            <input className="form-input" type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Jane Doe" required />
          </div>

          <div className="form-field">
            <label className="form-label">Role / Company</label>
            <input className="form-input" type="text" value={role} onChange={e => setRole(e.target.value)} placeholder="CEO, Company Name" />
          </div>

          <div className="form-field">
            <label className="form-label">Your Review *</label>
            <textarea className="form-input form-textarea" value={body} onChange={e => setBody(e.target.value)} placeholder="Tell us about your experience..." rows={4} required />
          </div>

          <div className="form-actions">
            <button type="button" className="btn-ghost" onClick={() => setOpen(false)}>Cancel</button>
            <button type="submit" className="btn-cta" disabled={!rating || !name.trim() || !body.trim()}>
              {submitted ? 'Thank you!' : 'Submit Review'}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}

export default TestimonialForm;
